import { myportfolio } from '../Data';
import styled from 'styled-components';
// import LazyLoad from "react-lazyload";
import { LazyLoadImage } from 'react-lazy-load-image-component';

function Portfolio() {
  return (
    <div className="card-inner active" id="works-card">
      <div className="row card-container">
        {/* Card Wrap */}
        <div className="card-wrap col col-m-12 col-t-12 col-d-8 col-d-lg-6">
          {/* <!-- Work Image --> */}
          {/* <div
            className="card-image col col-m-12 col-t-12 col-d-4 col-d-lg-6"
            style={{ backgroundImage: `url(images/profile3.jpg)` }}
          ></div> */}

          {/* Inner Top */}
          <div className="content inner-top">
            <div className="row">
              <div className="col col-m-12 col-t-12 col-d-12 col-d-lg-12">
                <div className="title-bg">Portfolio</div>
              </div>
            </div>
          </div>

          {/* Works */}
          <div className="content works">
            <div className="row">
              <div className="col col-m-12 col-t-5 col-d-5 col-d-lg-5">
                {/* <!-- title --> */}
                <div className="title">
                  <span>My</span> Portfolio
                </div>
              </div>
              <div className="col col-m-12 col-t-7 col-d-7 col-d-lg-7">
                {/* <!-- filters --> */}
                <div className="filter-menu filter-button-group">
                  {myportfolio.filter.map((item, id) => {
                    const { label, value } = item;
                    return (
                      <div
                        key={id}
                        className={`f_btn ${label === 'All' ? 'active' : null}`}
                      >
                        <label>
                          <input
                            type="radio"
                            name="fl_radio"
                            value={`${value}`}
                          />
                          {label}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            {/* <LazyLoad> */}
            {/* <!-- work items --> */}
            <div className="row grid-items">
              {myportfolio.works.map((item, id) => {
                const {
                  type,
                  projecttype,
                  design,
                  link,
                  thumbnailimage,
                  portfolioimage,
                  title,
                  content,
                  projectlink,
                } = item;
                return (
                  <div
                    key={id}
                    className={`col col-m-6 col-t-4 col-d-4 col-d-lg-4
                    grid-item
                    ${type}`}
                  >
                    <div className="box-item card-box">
                      <div className="image">
                        <a
                          href={content ? `#${link}` : `${link}`}
                          className={`has-popup-${design}`}
                        >
                          <img src={`${thumbnailimage}`} alt={`${title}`} />
                          <span className="info">
                            <span className="icon la la-camera-retro"></span>
                          </span>
                        </a>
                      </div>

                      <div className="desc">
                        <a
                          href={content ? `#${link}` : `${link}`}
                          className={`name has-popup-${design}`}
                        >
                          {title}
                        </a>
                        <ProjectType>{projecttype}</ProjectType>

                        <div
                          className="category"
                          style={{ textTransform: 'Capitalize' }}
                        >
                          {type}
                        </div>
                        {content ? (
                          <div
                            id={`${link}`}
                            className="popup-box mfp-fade mfp-hide"
                          >
                            <div className="content">
                              <div className="image">
                                {/* <LazyLoad> */}
                                <LazyLoadImage
                                  src={`${portfolioimage}`}
                                  alt=""
                                />
                                {/* </LazyLoad> */}
                              </div>
                              <div className="desc">
                                <div className="post-box">
                                  <h1>{title}</h1>
                                  <ProjectType>{projecttype}</ProjectType>
                                  <div className="blog-detail">{type}</div>

                                  {content.map((value, id) => {
                                    return (
                                      <div
                                        key={id}
                                        className="blog-content"
                                        dangerouslySetInnerHTML={{
                                          __html: value,
                                        }}
                                      />
                                    );
                                  })}
                                  {projectlink ? (
                                    <a
                                      target="_blank"
                                      rel="noreferrer"
                                      href={`${projectlink}`}
                                      className="button"
                                    >
                                      <span className="text">View Project</span>
                                      <span className="arrow"></span>
                                    </a>
                                  ) : (
                                    <span className="button">
                                      Not Active Anymore
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {/* </LazyLoad> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;

const ProjectType = styled.div`
  font-size: 12px;
  color: #5ac24e;
  text-transform: capitalize;
`;
